// Откуда пользователь пришёл на текущий экран — для аналитических событий с
// полем «точка входа» (`course_workspace_opened.entry`).
//
// Зачем модуль, а не `document.referrer`: в SPA referrer остаётся адресом
// первой загрузки и после десятка переходов врёт. Router-состояние тоже не
// подходит напрямую — `resolvedLocation` к моменту эффекта экрана уже равен
// новому пути.
//
// Порядок работы опирается на порядок эффектов React: эффекты ДЕТЕЙ выполняются
// раньше эффекта родителя, поэтому экран, читающий `getPreviousPathname()` в
// своём `useEffect`, видит ещё старое значение, а `recordNavigation` из
// `__root.tsx` перезапишет его после. Ломкой эту связь не назвать — она
// зафиксирована тестом `nav-trail.test.ts` и комментарием в `__root.tsx`.

/** Путь, на котором пользователь находился ДО текущего экрана. */
let previousPathname: string | null = null;
/** Текущий путь — нужен, чтобы отличить реальный переход от ре-рендера. */
let currentPathname: string | null = null;

/**
 * Зафиксировать переход. Вызывается ОДИН раз на приложение — из `__root.tsx`.
 * Повторный вызов с тем же путём (ре-рендер, смена только search-параметров)
 * историю не двигает: иначе «предыдущим» стал бы сам экран.
 */
export function recordNavigation(pathname: string): void {
	if (pathname === currentPathname) return;
	previousPathname = currentPathname;
	currentPathname = pathname;
}

/**
 * Путь предыдущего экрана. `null` — холодный старт (прямая ссылка, открытие из
 * уведомления, восстановление сессии), и это значимый случай, а не «не знаю».
 */
export function getPreviousPathname(): string | null {
	return previousPathname;
}

/** Точки входа каталога аналитики (`course_workspace_opened.entry`). */
export type CourseWorkspaceEntry = "list" | "dashboard" | "deep-link" | "notification" | "search";

/**
 * Классификация предыдущего пути в точку входа воркспейса курса.
 *
 * Чистая функция — тестируется без роутера. Всё, что не опознано (в том числе
 * `null` холодного старта), — `deep-link`: честнее, чем приписать переход
 * списку курсов.
 */
export function resolveCourseWorkspaceEntry(previous: string | null): CourseWorkspaceEntry {
	if (!previous) return "deep-link";
	if (previous === "/" || previous.startsWith("/dashboard")) return "dashboard";
	if (previous.startsWith("/search")) return "search";
	if (previous.startsWith("/notifications")) return "notification";
	// `/courses`, `/courses/` и `/courses/<другой курс>` — все они список или
	// соседний курс, то есть переход внутри раздела.
	if (previous.startsWith("/courses")) return "list";
	if (previous.startsWith("/library")) return "list";
	return "deep-link";
}
